import React, { createContext, useState, useContext } from 'react';
import tabs from 'theme/tabs';

const MainCollapseContext = createContext();

export default function MainCollapseProvider({ children }) {
    const [mainCollapse, setMainCollapse] = useState({
        // height: 'min',
        // withContent: false,
        componentToRender: false,
        visible: false,
        // arrowPosition: true,
        // from: tabs.events.slug,
        // withHideCity: false
    });

    return (
        <MainCollapseContext.Provider value={{ mainCollapse, setMainCollapse }}>
            {children}
        </MainCollapseContext.Provider>
    );
}

export function useMainCollapse() {
    const context = useContext(MainCollapseContext);

    if (!context) throw new Error('useMainCollapse must be used within a MainCollapseProvider');

    const { mainCollapse, setMainCollapse } = context;
    return { mainCollapse, setMainCollapse };
}